(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["directorio-medico"] && !Shopify.designMode) return;
  try {
    
  if (typeof Fuse === 'undefined') {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/fuse.js@7.1.0';
    script.onload = function() {
      initializeSearch();
    };
    document.head.appendChild(script);
  } else {
    initializeSearch();
  }

  const nameInput = document.getElementById('searchInput');
  const specialtyInput = document.getElementById('searchInputEspecialidad');

  function removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }


  function capitalize(str) {
    str = str.trim().toLowerCase();
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function obtenerEspecializacionesUnicas(doctores) {
    console.log("doctores: ", doctores);
      const area = new Set();
      doctores.forEach(doctor => {
          console.log("area de doctor: ", doctor.AreasLong);
          if (doctor.AreasLong){
              const areasLong = doctor.AreasLong.split(",");
              console.log("areasLong: ", areasLong)
              areasLong.forEach(singleArea => {
                  console.log("the area is: ", singleArea)
                  area.add(singleArea.trim());
              });
          }
          //let doctorArea = doctor.AreasLong;
          //area.add(doctorArea);
      });
    
      const especializaciones = new Set();
      doctores.forEach(doctor => {
          const especialidades = doctor.Especializaciones.split(",");
          especialidades.forEach(especialidad => {
              especializaciones.add(especialidad.trim());
          });
      });
      return Array.from(area);
  }

  function generarOpcionesEspecialidades(areas) {
    const select = document.getElementById("searchInputEspecialidad");
    select.innerHTML = '<option selected value="">Selecciona una opción</option>';
    areas.forEach(area => {
        const cap = capitalize(area);
        const option = document.createElement("option");
        option.value = area;
        option.textContent = cap;
        select.appendChild(option);
    });
  }
  
   async function getFileByName(filename) {
      const query = `
        query getFileByName($filename: String!) {
          files(first: 1, query: $filename) {
            edges {
              node {
                id
                alt
                createdAt
                preview {
                  image {
                    originalSrc
                    altText
                  }
                }
              }
            }
          }
        }
      `;
    
      const variables = { filename };
    
      try {
        const response = await fetch("https://policlinicametropolitana.org/admin/api/2025-01/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Access-Token": "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", // Reemplaza con tu token de acceso
          },
          body: JSON.stringify({ query, variables }),
        });
    
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        const data = await response.json();
        console.log(data);
    
        if (!data.data.files.edges.length) {
          console.error(`No file found with the name: ${filename}`);
          return null;
        }
    
        const file = data.data.files.edges[0].node;
    
        // Devuelve la URL de la imagen desde preview.image.originalSrc
        return file.preview.image.originalSrc;
      } catch (error) {
        console.error("Error fetching file from Shopify:", error);
        return null;
      }
    }

async function performSearch(fuse, allDoctors) {
    const startTime = Date.now();
    const nameQuery = removeAccents(nameInput.value.trim().toLowerCase());
    const specialtyQuery = specialtyInput.value.trim();

    if (nameQuery.length > 0 && nameQuery.length < 3) {
      document.getElementById('filteredResults').innerHTML = '<p>Por favor, introduce al menos 3 caracteres para buscar por nombre.</p>';
      return;
    }
    
    if (nameQuery.length < 3 && !specialtyQuery) {
        document.getElementById('filteredResults').innerHTML = '<h3 class="placeholderText">Realiza tu búsqueda...</h3>';
        return;
    }

    const socialIcons = {
      "Tiktok": "https://cdn.shopify.com/s/files/1/0593/6211/5749/files/tiktok.svg",
      "Linkedin": "https://cdn.shopify.com/s/files/1/0593/6211/5749/files/linkedin.svg",
      "Telegram": "https://cdn.shopify.com/s/files/1/0593/6211/5749/files/telegram.svg",
      "Instagram": "https://cdn.shopify.com/s/files/1/0593/6211/5749/files/instagram_icon_30bb3308-8885-4ff5-9a46-c630c0a1fc5a.svg",
      "X": "https://cdn.shopify.com/s/files/1/0593/6211/5749/files/x-twitter.svg",
      "Facebook":"https://cdn.shopify.com/s/files/1/0593/6211/5749/files/facebook_icon_9229c4a9-7354-4304-a8b4-74b207542abe.svg",
      "Threads": "https://cdn.shopify.com/s/files/1/0593/6211/5749/files/threads_icon_da4a1af9-a552-48f8-88b3-664d9834b7ed.svg",
      "Email1":"https://cdn.shopify.com/s/files/1/0593/6211/5749/files/mail_icon_13b20ab7-1204-4bd1-b3a7-18430f862e97.svg"
    };

    // 1. Filtrado exacto por especialidad
    let filteredDoctors = allDoctors;
    if (specialtyQuery) {
        filteredDoctors = allDoctors.filter(doctor => {
            if (doctor.AreasLong) {
                const especialidadesArray = doctor.AreasLong.split(',').map(e => e.trim());
                return especialidadesArray.includes(specialtyQuery);
            }
            return false;
        });
    }

    // 2. Búsqueda de subcadena exacta por nombre, ignorando acentos y palabras
    let doctorsByName = filteredDoctors;
    if (nameQuery) {
        const queryWords = nameQuery.split(' ');
        doctorsByName = filteredDoctors.filter(doctor => {
            const fullNormalizedName = removeAccents(`${doctor.Nombres} ${doctor.Apellidos}`).toLowerCase();
            return queryWords.every(word => fullNormalizedName.includes(word));
        });
    }

    let results = doctorsByName.map(doctor => ({ item: doctor }));
    if (nameQuery) {
      const isMultiWordSearch = nameQuery.includes(' ');
      
      if (isMultiWordSearch) {
          results.sort((a, b) => {
              const nameA = `${a.item.Nombres} ${a.item.Apellidos}`.toUpperCase();
              const nameB = `${b.item.Nombres} ${b.item.Apellidos}`.toUpperCase();
              return nameA.localeCompare(nameB);
          });
      } else {
          results.sort((a, b) => {
            const nameA = removeAccents(`${a.item.Nombres} ${a.item.Apellidos}`).toLowerCase();
            const nameB = removeAccents(`${b.item.Nombres} ${b.item.Apellidos}`).toLowerCase();
            
            const normalizedApellidosA = removeAccents(a.item.Apellidos).toLowerCase();
            const normalizedApellidosB = removeAccents(b.item.Apellidos).toLowerCase();
            
            const isExactLastNameMatchA = normalizedApellidosA === nameQuery || normalizedApellidosA.startsWith(`${nameQuery} `);
            const isExactLastNameMatchB = normalizedApellidosB === nameQuery || normalizedApellidosB.startsWith(`${nameQuery} `);

            if (isExactLastNameMatchA !== isExactLastNameMatchB) {
              return isExactLastNameMatchA ? -1 : 1;
            }

            const isExactMatchA = nameA.includes(` ${nameQuery} `) || nameA.startsWith(`${nameQuery} `) || nameA.endsWith(` ${nameQuery}`);
            const isExactMatchB = nameB.includes(` ${nameQuery} `) || nameB.startsWith(`${nameQuery} `) || nameB.endsWith(` ${nameQuery}`);

            if (isExactMatchA !== isExactMatchB) {
                return isExactMatchA ? -1 : 1;
            }
            
            if (isExactMatchA && isExactMatchB) {
                const indexA = nameA.indexOf(nameQuery);
                const indexB = nameB.indexOf(nameQuery);

                const startsWithA = indexA === 0;
                const startsWithB = indexB === 0;

                if (startsWithA !== startsWithB) {
                    return startsWithA ? -1 : 1;
                }
                
                const nameAOriginal = `${a.item.Nombres} ${a.item.Apellidos}`.toUpperCase();
                const nameBOriginal = `${b.item.Nombres} ${b.item.Apellidos}`.toUpperCase();
                return nameAOriginal.localeCompare(nameBOriginal);
            }

            if (!isExactMatchA && !isExactMatchB) {
                const nameAOriginal = `${a.item.Nombres} ${a.item.Apellidos}`.toUpperCase();
                const nameBOriginal = `${b.item.Nombres} ${b.item.Apellidos}`.toUpperCase();
                return nameAOriginal.localeCompare(nameBOriginal);
            }
            
            return 0;
          });
      }
    } else {
        results.sort((a, b) => {
            const nameA = `${a.item.Nombres} ${a.item.Apellidos}`.toUpperCase();
            const nameB = `${b.item.Nombres} ${b.item.Apellidos}`.toUpperCase();
            return nameA.localeCompare(nameB);
        });
    }

    const cardsHtml = await Promise.all(results.map(async result => {
        let imageUrl = "https://cdn.shopify.com/s/files/1/0664/3151/6716/files/Portrait_Placeholder.png";
        if (result.item.image) {
            const fetchedUrl = await getFileByName(result.item.image);
            if (fetchedUrl) {
                imageUrl = fetchedUrl;
            }
        }

        const specialties = result.item.Especializaciones.split(",");
        const specialtiesHtml = specialties.map((specialty) => {
          const cap = capitalize(specialty);
          return `<p><img src="https://cdn.shopify.com/s/files/1/0593/6211/5749/files/checked-radio-button.svg" height="18" width="18" />${cap}</p>`;
        }).join('');

        let telefonoConsultorio = "";
        let telefonoDirecto = "";
        let socialLinks = "";
        let ubicacionHtml = "";
        let mailHtml = "";
        let areasHtml = "";
        
        for (const key in result.item) {
            if(key.startsWith("Telefono_") && !key.includes("Directo") && result.item[key] !== null ){
              telefonoConsultorio += `
                <p><img src="https://cdn.shopify.com/s/files/1/0593/6211/5749/files/cellphone.svg" height="18" width="18" /><a href="tel:${result.item[key]}">${result.item[key]}</a></p>
              `;
            }
            if(key.startsWith("Telefono_Directo") && result.item[key] !== null){
              telefonoDirecto += `
                <p><img src="https://cdn.shopify.com/s/files/1/0593/6211/5749/files/deskphone.svg" height="18" width="18" /><a href="tel:${result.item[key]}">${result.item[key]}</a></p>
              `;
            }
            if(key.startsWith("Email1") && result.item[key] !== null){
              mailHtml += `
                <p><img src="https://cdn.shopify.com/s/files/1/0664/3151/6716/files/Email.svg" height="18" width="18" /><a href="mailto:${result.item[key]}">${result.item[key]}</a></p>
              `;
            }

            if(key == "Piso" && result.item[key]){
              ubicacionHtml += `
                <p><img src="https://cdn.shopify.com/s/files/1/0593/6211/5749/files/floor.svg" height="18" width="18" />Piso: ${result.item.Piso}</p>
              `;
            }
            
           if(key == "Consultorio" && result.item[key]){
              ubicacionHtml += `
                <p><img src="https://cdn.shopify.com/s/files/1/0593/6211/5749/files/consultory.svg" height="18" width="18" />Consultorio: ${result.item.Consultorio}</p>
              `;
            }
            
            if (key == "AreasLong" && result.item[key]){
              areasHtml += result.item[key].replace(",", " - ")
            }
          
            if(socialIcons[key] && result.item[key] !== null){
              if(key == "Email1"){
                socialLinks += `
                  <a href="mailto:${result.item[key]}"><img src="${socialIcons[key]}" width="40" height="40" /></a>
                `;
              }else{
                socialLinks += `
                  <a href="${result.item[key]}" target="_blank"><img src="${socialIcons[key]}" width="40" height="40" /></a>
                `;
              }
            }
        }
        return `
          <div class="doctor-card">
            <div class="card-header">
              <img src="${imageUrl}" width="120" height="120" />
              <div class="header-content">
                <div class="name">${result.item.Nombres} ${result.item.Apellidos}</div>
                <div class="especialidad">${areasHtml}</div>
              </div>
            </div>
            <div class="card-body">
              <div class="body-column">
                <h3>Especialidades</h3>
                ${specialtiesHtml}
              </div>
              <div class="body-column">
                <h3>Ubicación</h3>
                ${ubicacionHtml}
              </div>
              <div class="body-column">
                <h3>Consultorio</h3>
                ${telefonoConsultorio}
              </div>
              <div class="body-column">
                <h3>Directo</h3>
                ${telefonoDirecto}
                ${mailHtml}
              </div>
            </div>
            <div class="card-footer">
              ${socialLinks}
            </div>
          </div>
        `;
    }));

    const filteredResults = document.getElementById('filteredResults');
    if (cardsHtml.length > 0) {
      filteredResults.innerHTML = cardsHtml.join('');
    } else {
      filteredResults.innerHTML = '<p>No se encontraron resultados.</p>';
    }
    const endTime = Date.now();
    const durationInMilliseconds = endTime - startTime;
    const durationInSeconds = durationInMilliseconds / 1000;
  }
  /*async function performSearch(fuse, allDoctors) {
    const startTime = Date.now();
    //const nameQuery = nameInput.value.trim();
    const nameQuery = removeAccents(nameInput.value.trim().toLowerCase());
    const specialtyQuery = specialtyInput.value.trim();

    if (nameQuery.length > 0 && nameQuery.length < 3) {
      document.getElementById('filteredResults').innerHTML = '<p>Por favor, introduce al menos 3 caracteres para buscar por nombre.</p>';
      return;
    }

    const socialIcons = {
      "Tiktok": "https://cdn.shopify.com/s/files/1/0593/6211/5749/files/tiktok.svg",
      "Linkedin": "https://cdn.shopify.com/s/files/1/0593/6211/5749/files/linkedin.svg",
      "Telegram": "https://cdn.shopify.com/s/files/1/0593/6211/5749/files/telegram.svg",
      "Instagram": "https://cdn.shopify.com/s/files/1/0593/6211/5749/files/instagram_icon_30bb3308-8885-4ff5-9a46-c630c0a1fc5a.svg",
      "X": "https://cdn.shopify.com/s/files/1/0593/6211/5749/files/x-twitter.svg",
      "Facebook":"https://cdn.shopify.com/s/files/1/0593/6211/5749/files/facebook_icon_9229c4a9-7354-4304-a8b4-74b207542abe.svg",
      "Threads": "https://cdn.shopify.com/s/files/1/0593/6211/5749/files/threads_icon_da4a1af9-a552-48f8-88b3-664d9834b7ed.svg",
      "Email1":"https://cdn.shopify.com/s/files/1/0593/6211/5749/files/mail_icon_13b20ab7-1204-4bd1-b3a7-18430f862e97.svg"
    };
    
    let filteredDoctors = allDoctors;
    if (specialtyQuery) {
      filteredDoctors = allDoctors.filter(doctor => {
          if (doctor.AreasLong) {
              const especialidadesArray = doctor.AreasLong.split(',').map(e => e.trim());
              return especialidadesArray.includes(specialtyQuery);
          }
          return false;
      });
    }

    let doctorsByName = filteredDoctors;
    if (nameQuery) {
        doctorsByName = filteredDoctors.filter(doctor => {
            const normalizedNombres = removeAccents(doctor.Nombres).toLowerCase();
            const normalizedApellidos = removeAccents(doctor.Apellidos).toLowerCase();
            return normalizedNombres.includes(nameQuery) || normalizedApellidos.includes(nameQuery);
        });
    }

    let results = doctorsByName.map(doctor => ({ item: doctor }));

if (nameQuery) {
    results.sort((a, b) => {
      const nameA = removeAccents(`${a.item.Nombres} ${a.item.Apellidos}`).toLowerCase();
      const nameB = removeAccents(`${b.item.Nombres} ${b.item.Apellidos}`).toLowerCase();
      
      const isExactMatchA = nameA.includes(` ${nameQuery} `) || nameA.startsWith(`${nameQuery} `) || nameA.endsWith(` ${nameQuery}`);
      const isExactMatchB = nameB.includes(` ${nameQuery} `) || nameB.startsWith(`${nameQuery} `) || nameB.endsWith(` ${nameQuery}`);

      // Criterio 1: Si solo uno es coincidencia exacta de palabra, ese va primero.
      if (isExactMatchA !== isExactMatchB) {
          return isExactMatchA ? -1 : 1;
      }
      
      // Criterio 2: Si ambos son coincidencias exactas de palabra
      if (isExactMatchA && isExactMatchB) {
          const indexA = nameA.indexOf(nameQuery);
          const indexB = nameB.indexOf(nameQuery);

          const startsWithA = indexA === 0;
          const startsWithB = indexB === 0;

          // Si uno empieza con la subcadena y el otro no, el que empieza va primero.
          if (startsWithA !== startsWithB) {
              return startsWithA ? -1 : 1;
          }
          
          // Si ambos o ninguno empiezan con la subcadena, el desempate es alfabético.
          const nameAOriginal = `${a.item.Nombres} ${a.item.Apellidos}`.toUpperCase();
          const nameBOriginal = `${b.item.Nombres} ${b.item.Apellidos}`.toUpperCase();
          return nameAOriginal.localeCompare(nameBOriginal);
      }

      // Criterio 3: Si ninguno es una coincidencia exacta, se ordena alfabéticamente
      if (!isExactMatchA && !isExactMatchB) {
          const nameAOriginal = `${a.item.Nombres} ${a.item.Apellidos}`.toUpperCase();
          const nameBOriginal = `${b.item.Nombres} ${b.item.Apellidos}`.toUpperCase();
          return nameAOriginal.localeCompare(nameBOriginal);
      }
      
      return 0;
    });
  } else {
    // Si no hay subcadena de búsqueda, simplemente ordenamos alfabéticamente
    results.sort((a, b) => {
        const nameA = `${a.item.Nombres} ${a.item.Apellidos}`.toUpperCase();
        const nameB = `${b.item.Nombres} ${b.item.Apellidos}`.toUpperCase();
        return nameA.localeCompare(nameB);
    });
  }

    // Procesar imágenes de forma asíncrona
    const cardsHtml = await Promise.all(results.map(async result => {
        // Obtener la URL de la imagen si existe, si no usar el placeholder
        let imageUrl = "https://cdn.shopify.com/s/files/1/0664/3151/6716/files/Portrait_Placeholder.png";
        if (result.item.image) {
            const fetchedUrl = await getFileByName(result.item.image);
            if (fetchedUrl) {
                imageUrl = fetchedUrl;
            }
        }

        const specialties = result.item.Especializaciones.split(",");
        const specialtiesHtml = specialties.map((specialty) => {
          const cap = capitalize(specialty);
          return `<p><img src="https://cdn.shopify.com/s/files/1/0593/6211/5749/files/checked-radio-button.svg" height="18" width="18" />${cap}</p>`;
        }).join('');

        let telefonoConsultorio = "";
        let telefonoDirecto = "";
        let socialLinks = "";
        let ubicacionHtml = "";
        let mailHtml = "";
        let areasHtml = "";
        
        for (const key in result.item) {
            if(key.startsWith("Telefono_") && !key.includes("Directo") && result.item[key] !== null ){
              telefonoConsultorio += `
                <p><img src="https://cdn.shopify.com/s/files/1/0593/6211/5749/files/cellphone.svg" height="18" width="18" /><a href="tel:${result.item[key]}">${result.item[key]}</a></p>
              `;
            }
            if(key.startsWith("Telefono_Directo") && result.item[key] !== null){
              telefonoDirecto += `
                <p><img src="https://cdn.shopify.com/s/files/1/0593/6211/5749/files/deskphone.svg" height="18" width="18" /><a href="tel:${result.item[key]}">${result.item[key]}</a></p>
              `;
            }
            if(key.startsWith("Email1") && result.item[key] !== null){
              mailHtml += `
                <p><img src="https://cdn.shopify.com/s/files/1/0664/3151/6716/files/Email.svg" height="18" width="18" /><a href="mailto:${result.item[key]}">${result.item[key]}</a></p>
              `;
            }

            if(key == "Piso" && result.item[key]){
              ubicacionHtml += `
                <p><img src="https://cdn.shopify.com/s/files/1/0593/6211/5749/files/floor.svg" height="18" width="18" />Piso: ${result.item.Piso}</p>
              `;
            }
            
           if(key == "Consultorio" && result.item[key]){
              ubicacionHtml += `
                <p><img src="https://cdn.shopify.com/s/files/1/0593/6211/5749/files/consultory.svg" height="18" width="18" />Consultorio: ${result.item.Consultorio}</p>
              `;
            }

            if (key == "AreasLong"){
              areasHtml += result.item[key].replace(",", " - ")
            }
          
            if(socialIcons[key] && result.item[key] !== null){
              if(key == "Email1"){
                socialLinks += `
                  <a href="mailto:${result.item[key]}"><img src="${socialIcons[key]}" width="40" height="40" /></a>
                `;
              }else{
                socialLinks += `
                  <a href="${result.item[key]}" target="_blank"><img src="${socialIcons[key]}" width="40" height="40" /></a>
                `;
              }
            }
        }
        return `
          <div class="doctor-card">
            <div class="card-header">
              <img src="${imageUrl}" width="120" height="120" />
              <div class="header-content">
                <div class="name">${result.item.Nombres} ${result.item.Apellidos}</div>
                <div class="especialidad">${areasHtml}</div>
              </div>
            </div>
            <div class="card-body">
              <div class="body-column">
                <h3>Especialidades</h3>
                ${specialtiesHtml}
              </div>
              <div class="body-column">
                <h3>Ubicación</h3>
                ${ubicacionHtml}
              </div>
              <div class="body-column">
                <h3>Consultorio</h3>
                ${telefonoConsultorio}
              </div>
              <div class="body-column">
                <h3>Directo</h3>
                ${telefonoDirecto}
                ${mailHtml}
              </div>
            </div>
            <div class="card-footer">
              ${socialLinks}
            </div>
          </div>
        `;
    }));

    const filteredResults = document.getElementById('filteredResults');
    if (cardsHtml.length > 0) {
      filteredResults.innerHTML = cardsHtml.join('');
    } else {
      filteredResults.innerHTML = '<p>No se encontraron resultados.</p>';
    }
    const endTime = Date.now();
    const durationInMilliseconds = endTime - startTime;
    const durationInSeconds = durationInMilliseconds / 1000;

    //  console.log(`The function performSearch took ${durationInSeconds} seconds to run.`);
  }*/
  
  async function initializeSearch() {
    const element = document.getElementById('filteredResults');
    let urlString = element.dataset.file;
    
    // Ensure it has the https protocol
    if (!urlString.startsWith("http")) {
      urlString = "https:" + urlString;
    }

    // Check if Shopify already included a '?' (like ?v=1234), 
    // and append the timestamp with '&' instead of '?'
    const separator = urlString.includes('?') ? '&' : '?';
    const fetchUrl = `${urlString}${separator}timestamp=${Date.now()}`;
    
    // Now fetch with both Shopify's version hash AND your timestamp
    const doctors = await fetch(fetchUrl);
    const doctorsJson = await doctors.json();

    const activeDoctors = doctorsJson.filter((doctor) => doctor.Activo && doctor.Web )
    const especializacionesUnicas = obtenerEspecializacionesUnicas(activeDoctors);
    
    generarOpcionesEspecialidades(especializacionesUnicas.sort());

/*
    const options = {
      includeScore: true,
      threshold: 0.2,
      ignoreLocation: true,
      keys: ['Nombres', 'Apellidos']
    };
*/
    const options = {
      includeScore: true,
      isCaseSensitive: false, // Opcional: si quieres ignorar mayúsculas
      includeMatches: true,
      findAllMatches: true,
      threshold: 0.0,
      ignoreLocation: true, 
      useExtendedSearch: true, 
      ignoreFieldNorm: true,
      tokenize: false,
      matchAllTokens: false,
      keys: ['Nombres', 'Apellidos']
    }
    const fuse = new Fuse(activeDoctors, options);
    
    document.getElementById('searchInput').addEventListener('input', () => performSearch(fuse, activeDoctors));
    document.getElementById('searchInputEspecialidad').addEventListener('change', () => performSearch(fuse, activeDoctors));
    document.getElementById('cleanFilter').addEventListener('click', () => {
      document.getElementById('searchInput').value = "";
      document.getElementById('searchInputEspecialidad').value = "";
      document.getElementById('filteredResults').innerHTML = '<h3 class="placeholderText">Realiza tu búsqueda...</h3>';
    });
  }

  } catch(e) { console.error(e); }
})();
})();
